import { useThemeProvider } from "../provider/theme-provider-internal";

export function useTheme() {
  return useThemeProvider();
}
